import { ActiveField, ActiveModel } from '@alt-point/active-models/src'
import { BeginChallengeResponse } from '@repo/api/web/models'

export class AuthModel extends ActiveModel {
  @ActiveField()
  login: string = ''

  @ActiveField()
  longSession: boolean = true

  @ActiveField({
    factory: [BeginChallengeResponse, undefined],
  })
  confirmation?: BeginChallengeResponse = undefined

  @ActiveField()
  code?: string = undefined
}
